<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <tabs ref="tab-grants" type="info" @activate-tab="activateTab" :value="GrantForm.cnEvaluationStatus == 'Preselected' ? 'Full Proposal' : 'Concept Note'" square>
          <tab-pane :id="'concept-note'" :label="'Concept Note'">
            <grant-wizard v-if="GrantForm.initialized" :is-editable="GrantForm.isEditable && GrantForm.disableConcept">
          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-settings-gear-63"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">PA Information and Project Description</p>
            </template>
            <cn-project-description></cn-project-description>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-money-coins"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">Organization Details</p>
            </template>
            <cn-organization-details></cn-organization-details>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-money-coins"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">ESMS pre-screening questions</p>
            </template>
            <cn-esms></cn-esms>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-puzzle-10"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">Application and supporting document upload</p>
            </template>
            <cn-documents-upload></cn-documents-upload>
          </grant-wizard-tab>

        </grant-wizard>
          </tab-pane>

        <tab-pane v-if="GrantForm.cnEvaluationStatus === 'Preselected'" :id="'full-proposal'" :label="'Full Proposal'">
        <grant-wizard v-if="GrantForm.initialized" :is-editable="GrantForm.isEditable || (GrantForm.isRevisionEditable && GrantForm.isOnARevisionTab)">
          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-settings-gear-63"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">PA Information and Project Description</p>
            </template>
            <project-description></project-description>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-money-coins"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">Organization Details</p>
            </template>
            <organization-details></organization-details>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-money-coins"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">ESMS pre-screening questions</p>
            </template>
            <esms></esms>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-puzzle-10"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">Full Proposal</p>
            </template>
            <full-proposal></full-proposal>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-puzzle-10"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">Budget</p>
            </template>
            <budget></budget>
          </grant-wizard-tab>

          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-puzzle-10"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">Application and supporting document upload</p>
            </template>
            <documents-upload></documents-upload>
          </grant-wizard-tab>

        </grant-wizard>
        </tab-pane>
                </tabs>
      </div>
    </div>
  </div>
</template>
<script>
  import DocumentsUpload from './Steps/DocumentsUpload'
  import OrganizationDetails from './Steps/OrganizationDetails'
  import ProjectDescription from './Steps/ProjectDescription'
  import Budget from './Steps/Budget'
  import FullProposal from './Steps/FullProposalUpload'
  import Esms from './Steps/EsmsQuestionnaire'

  import CnDocumentsUpload from '../ConceptNote/Steps/DocumentsUpload'
  import CnOrganizationDetails from '../ConceptNote/Steps/OrganizationDetails'
  import CnEsms from '../ConceptNote/Steps/EsmsQuestionnaire'
  import CnProjectDescription from '../ConceptNote/Steps/ProjectDescription'

  import {EventBus} from '@/event-bus.js';
  import swal from 'sweetalert2';
  import {TabPane, Tabs, GrantWizard, GrantWizardTab} from 'src/components';
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    components: {
      GrantWizard,
      GrantWizardTab,
      DocumentsUpload,
      OrganizationDetails,
      ProjectDescription,
      Budget,
      FullProposal,
      Esms,
      TabPane,
      Tabs,
      CnDocumentsUpload,
      CnOrganizationDetails,
      CnEsms,
      CnProjectDescription
    },
    /*beforeCreate(){
      if(this.GrantForm.model.technical){
        GrantForm.model.technical = GrantForm.model.cndescription.concat(GrantForm.model.cnorgnization);
      }
    },*/
    created() {
      EventBus.$off('set-active-tab');

      EventBus.$on('wizard-save-progress', data => {
        this.onBeforeSaveProgress(data);
      });

      EventBus.$on('wizard-complete-progress', data => {
        this.onBeforeCompleteProgress(data);
      });
    },
    methods: {
      async activateTab(ev)
            {
                //GrantForm.fp == 1;
                GrantForm.isFullProposal = ev.id === 'full-proposal';
            },
      async onBeforeSaveProgress(data) {
        /*let valid = await this.validate();
        if (valid) {
          EventBus.$emit('grant-save-progress', data);
        }*/
        EventBus.$emit('grant-save-progress', data);
      },

      async onBeforeCompleteProgress(data) {
        let valid = await this.validate();
        if(GrantForm.isRevisionEditable){
            valid = true;
        }
        if (!valid) {
          return;
        }

        var submitConfirmation = await this.showPreSubmitNotification().then((result) => {
          return result.value ? true : false;
        });

        if (submitConfirmation) {
          EventBus.$emit('grant-complete-progress', data);
        }
      },

      async validate() {
        let valid = true;
        let vm = this;
        let mandatoryFields = [
          {
            translation: vm.$t('medium_grant.technical__1_region'),
            value: GrantForm.regionId
          },
          {
            translation: 'Upload completed full proposal',
            value: GrantForm.files.technical.appTemplateCompleted
          },
          {
            translation: 'Diagnostic tool document',
            value: GrantForm.files.technical.diagnosticToolDoc
          },
          /*{
            translation: vm.$t('medium_grant_cn.document_upload_esms_questionnaire'),
            value: GrantForm.files.technical.fullProposalEsmsQuestionnaire
          },*/
          {
            translation: vm.$t('medium_grant_cn.document_upload_applicant_declaration'),
            value: GrantForm.files.technical.fullProposalApplicantDeclaration
          },
          /*{
            translation: vm.$t('medium_grant_cn.document_upload_coapplicant_declaration'),
            value: GrantForm.files.technical.fullProposalCoapplicantDeclarationDocument
          },*/
          {
            translation: 'Upload detailed budget',
            value: GrantForm.files.budget.appCompletedBudgetTable
          }
        ];

        let errorFields = [];
        mandatoryFields.forEach(item => {
          if (item.value === undefined || !item.value || (Array.isArray(item.value) && !item.value.length) || (typeof item.value == "object" && Object.keys(item.value).length == 0 )) {
            errorFields.push(item.translation);
          }
        })

        if (errorFields.length) {
          valid = false;
          if(!GrantForm.isRevisionEditable){
            await this.showNotificationMandatoryFields(errorFields);
          }

          EventBus.$emit('set-active-tab', {
            masterNickname: 'technical',
            masterIndex: 0,
            childIndex: 0,
            validate: true
          });
        }
        return valid;
      },

      showNotificationMandatoryFields(fields) {
        for (var i = 0; i < fields.length; i++) {
          fields[i] = "* " + fields[i];
        }
        let fieldsHtml = '<div class="text-danger">' + fields.join("<br>") + '</div>';
        return swal.fire({
          title: this.$t('general.notification__warning'),
          html: this.$t('general.notification__mandatory_fields', [fieldsHtml]).split("\n").join("<br>"),
          type: 'warning',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          confirmButtonText: 'OK'
        })
      },

      showPreSubmitNotification() {
        return swal.fire({
          title: this.$t('general.notification__warning'),
          html: this.$t('general.notification__pre_submit_application').split("\n").join("<br>"),
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          confirmButtonText: this.$t('general.notification__submit_application'),
          cancelButtonClass: 'ml-3 btn btn-danger btn-fill',
          cancelButtonText: this.$t('general.notification__cancel_submit_application'),
        })
      }
    }
  };
</script>
